import React, { useState, useEffect } from "react";
import BookNow from "../bookNow/bookNow";
import "./gallery.css";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const imageNames = [
  "BaliNet.jpg", "Interior1.jpg", "Interior2.jpg", "Interior3.jpg",
  "Interior4.jpg", "Interior5.jpg", "Interior6.jpg", "Interior7.jpg",
  "Living1.jpg", "Living2.jpg", "OpenDeck1.jpg", "OpenDeck2.jpg",
  "OutsideView1.jpg", "OutsideView2.jpg", "OutsideView3.jpg",
  "SwimmingPool1.jpg", "SwimmingPool2.jpg",
];

// Hand-crafted layout classes for a perfect 17-image collage
const layoutClasses = [
  'big', 'normal', 'normal', 'normal', 'normal',
  'tall', 'wide', 'normal', 'normal', 'normal',
  'wide', 'wide', 'normal', 'normal', 'normal',
  'normal', 'normal'
];

const images = imageNames.map((imageName, index) => ({
  src: require(`../../images/gallery/${imageName}`),
  alt: imageName.split('.')[0],
  layoutClass: layoutClasses[index] || 'normal',
}));

const Gallery = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openImageModal = (index) => {
    setSelectedImageIndex(index);
  };

  const closeImageModal = () => {
    setSelectedImageIndex(null);
  };

  const showNextImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const showPrevImage = () => {
    setSelectedImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const selectedImage =
    selectedImageIndex !== null ? images[selectedImageIndex].src : null;

  return (
    <>
      <div className="relative w-full md:min-h-screen h-[75%]">
        {/* Background Image - Full Width */}
        <div className="absolute inset-0 w-full h-full  bg-cover bg-center bgGalleryBanner z-0"></div>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
        {/* Content Wrapper */}
        <div className="relative z-10 flex flex-col items-center justify-center md:h-screen h-[700px] text-center text-white px-4">
          <div className="flex flex-col gap-4 ">
            <div className="flex gap-3 justify-center">
              <div className="text-base  poppins-medium">HOME</div>
              <div className="text-base poppins-medium">/</div>
              <div className="text-base poppins-medium">GALLERY</div>
            </div>
            <h2 className="text-3xl md:text-6xl font-normal ">GALLERY</h2>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 mt-10">
        <div className="text-xl font-medium text-[#585858] poppins-medium text-center">
          EXPLORE VILLA
        </div>
        <div className="md:text-[46px] text-[32px] md:w-[600px] mx-auto font-bold text-[#672220] text-center">
          Indulge in Luxury: Our Exclusive Amenities
        </div>
      </div>
      <div className="gallery-container max-w-[1440px] mx-auto py-4 px-4">
        {images.map((image, index) => (
          <div
            key={index}
            className={`gallery-item ${image.layoutClass}`}
            onClick={() => openImageModal(index)}
          >
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>

      <Modal
        open={selectedImageIndex !== null}
        footer={null}
        onCancel={closeImageModal}
        width={isMobile ? "95%" : "60%"}
        closeIcon={<CloseOutlined style={{ color: "#000000" }} />}
      >
        {selectedImageIndex !== null && (
          <div className="relative">
            <img
              src={images[selectedImageIndex].src}
              alt="Selected"
              className="w-full h-auto"
            />
            <button
              className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full p-2"
              onClick={showPrevImage}
            >
              &#10094;
            </button>
            <button
              className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full p-2"
              onClick={showNextImage}
            >
              &#10095;
            </button>
          </div>
        )}
      </Modal>
      <BookNow />
    </>
  );
};

export default Gallery;
